// React
import React, { useState, useEffect } from "react";

import { generateAuthHeader } from "../../../authHeader";

import { Auth } from "aws-amplify";

import {
  Row,
  Spin,
  Divider,
  Menu,
  Typography,
  Button,
  DatePicker,
  Form,
  Input,
  Space,
  Slider,
  Switch,
  InputNumber,
  Rate,
  Col,
  Select,
  Card,
  Checkbox,
  Collapse,
} from "antd";

import { BASE_URL } from "../../../constants.js";
import { getDetailedBundleInfo, getJobInfo } from "../../../apiCalls.js";

import {
  vendorIds,
  vendorNames,
  showType,
  videoAssets,
  imageAssets,
  contentType,
  parentalRating,
  resolution,
  countries,
  locale,
  genres,
  sampleComposerCategorizedPayloadInProgress,
  sampleComposerCategorizedPayload,
  goodJob,
  badJob,
} from "./fieldTypes";
import AssetCard from "./AssetCard";

import {
  Route,
  useParams,
  useLocation,
  useHistory,
  useRouteMatch,
} from "react-router-dom";
import Title from "antd/lib/typography/Title";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import TextArea from "antd/lib/input/TextArea";
import moment from "moment";
const { Text } = Typography;
const { Option } = Select;
const { Panel } = Collapse;

const optionGenerator = (options) =>
  (options || []).map((o) => <Option value={o}>{o}</Option>);

const assetPathPreprocessor = (vendorName, assetClass) => {
  const processedAssetClass = {};

  Object.keys(assetClass).forEach((type) => {
    if (assetClass[type]) {
      processedAssetClass[type] = assetClass[type].map((typeInstance) => ({
        ...typeInstance,
        path: `/${vendorName}/${typeInstance.path}`,
        fixed: typeInstance.fixed ? true : false,
      }));
    }
  });

  return processedAssetClass;
};

const CreateBundleForm = (props) => {
  const { incompleteBundles, isIncompleteBundlesLoaded } = props;
  const { hubId } = useParams();
  console.log({ AAA: 11 });

  const [form] = Form.useForm();

  let location = useLocation();
  let history = useHistory();
  let match = useRouteMatch("/delivery/hub/:hubId/:keyTab");

  const onFinish = (fieldsValue) => {
    console.log(fieldsValue);
    // Should format date value before submit.
    // console.log(fieldsValue["releaseDate"]);
    // const vendorName = fieldsValue["vendorName"];
    // const values = {
    //   ...fieldsValue,
    //   releaseDate: fieldsValue["releaseDate"].format("YYYY-MM-DDTHH:mm:ssZ"),
    //   rating: String((fieldsValue["rating"] / 10).toFixed(1)),
    //   year: String(fieldsValue["year"]),
    //   awards: String(fieldsValue["awards"]),
    //   runtime: String(fieldsValue["runtime"]),
    //   videoAssets: assetPathPreprocessor(
    //     vendorName,
    //     fieldsValue["videoAssets"]
    //   ),
    //   imageAssets: assetPathPreprocessor(
    //     vendorName,
    //     fieldsValue["imageAssets"]
    //   ),
    // };
    console.log("Received values of form: ", fieldsValue);
    getDetailedBundleInfo(fieldsValue.bundleId);
  };

  // form.getFieldDecorator("kidAllowed", { initialValue: true });

  const fieldRequiredConfig = { rules: [{ required: true }] };
  const fieldRequiredNumberConfig = {
    rules: [{ type: "number", required: true, min: 0 }],
  };
  // const fieldRequiredConfig = {};

  const config = {
    rules: [
      {
        type: "object",
        required: true,
        message: "Please select release date!",
      },
    ],
  };

  // window.a = createIngestJob;
  window.d = getJobInfo;
  // window.b = goodJob;
  // window.c = badJob;
  // window.moment = moment;

  // const formItemLayout = {
  //   labelCol: {
  //     xs: { span: 24 },
  //     sm: { span: 4 },
  //   },
  //   wrapperCol: {
  //     xs: { span: 24 },
  //     sm: { span: 20 },
  //   },
  // };
  const formItemLayout = {
    // labelCol: { span: 12 },
    // wrapperCol: { span: 14 },
  };
  const formItemLayoutWithOutLabel = {
    wrapperCol: {
      xs: { span: 24, offset: 0 },
      sm: { span: 20, offset: 4 },
    },
  };
  console.log(form.getFieldValue("rating"));

  return (
    <React.Fragment>
      {/* <Row align="space-between" justify="center">
        <Title level={3}>Create Bundle</Title>
      </Row> */}
      <Row>
        <Form
          form={form}
          name="locate_bundle"
          onFinish={onFinish}
          style={{ width: "95%" }}
          hideRequiredMark
          scrollToFirstError
          {...formItemLayout}
          // initialValues={{
          //   kidAllowed: false,
          //   censorshipAllowed: false,
          //   streamable: false,
          //   wishable: false,
          // }}
          initialValues={{}}
        >
          <Title level={4}>Delete Bundle</Title>
          <Form.Item
            name="bundleId"
            label="Bundle ID"
            hasFeedback
            {...fieldRequiredConfig}
          >
            <Input placeholder="Please enter bundle ID" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Locate Bundle
            </Button>
          </Form.Item>
        </Form>
      </Row>
    </React.Fragment>
  );
};

export default CreateBundleForm;
